import $ from 'jquery'

$(document).ready(function() {
	if (!$('body').hasClass('home')) {
		return
	}

	bannerTitle()

	const $homeBannerSlick = $('.banner-imgaes')
	const homeBannerArg = {
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		fade: true,
		autoplaySpeed: 4000,
		arrows: false,
		dots: true
	}
	$homeBannerSlick.slick(homeBannerArg)

	$('#scroll-down-arrow').on('click', function() {
		$('html, body').animate(
			{
				scrollTop: $(window).height()
			},
			800
		)
		$(this).remove()
	})

	//Question block events handlers
	$('.questions .single-item .title').on('click', function() {
		$(this)
			.siblings('.hidden-answer')
			.fadeIn(300)
	})

	$('.questions .close-icon').on('click', function() {
		$(this)
			.closest('.hidden-answer')
			.fadeOut(300)
	})
})

function bannerTitle() {
	const $homeBannerMultiLines = $('.banner-multilines')

	if ($(window).width() > 1023) {
		$homeBannerMultiLines
			.html(function() {
				return $(this)
					.html()
					.split('<br>')
					.map(item => '<span>' + item + '</span><br>')
			})
			.addClass('splitted')
			.removeClass('joined')
	} else {
		$homeBannerMultiLines
			.html(function() {
				return $(this)
					.html()
					.replace(/(<span>|<\/span>)/gi, '')
			})
			.removeClass('splitted')
			.addClass('joined')
	}
}

export { bannerTitle }
